

import { useEffect, useState } from "react";
import axios from "axios";
import { API_URL } from "../config";

function Course() {
  const [searchTerm, setSearchTerm] = useState("");
  const [booking, setBooking] = useState([]);
  const filteredTrips = booking.filter(booking => booking.firstname?.toLowerCase().includes(searchTerm.toLowerCase()));
  
  useEffect(() => { fetchBooking(); }, []);
  const fetchBooking = async () => {
    try {
      const res = await axios.get(`${API_URL}/kidsCourses`);
      setBooking(res.data);
    } catch (err) {
      console.error("error", err);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this enrollment?")) return;
    try {
      await axios.delete(`${API_URL}/kidsCourses/${id}`);
      fetchBooking();
    } catch (err) {
      console.error("error 2 ", err)
    }
  };

  const [booking2, setBooking2] = useState([]);
  const filteredTrips2 = booking2.filter(booking2 => booking2.firstname?.toLowerCase().includes(searchTerm.toLowerCase()));
  
  useEffect(() => { fetchBooking2(); }, []);
  const fetchBooking2 = async () => {
    try {
      const res = await axios.get(`${API_URL}/diveCourses`);
      setBooking2(res.data);
    } catch (err) {
      console.error("error", err);
    }
  };

  const handleDelete2 = async (id) => {
    if (!window.confirm("Are you sure you want to delete this enrollment?")) return;
    try {
      await axios.delete(`${API_URL}/diveCourses/${id}`);
      fetchBooking2();
    } catch (err) {
      console.error("error 2 ", err)
    }
  };

  return (
    <div className="p-6">
      {/* Header Card */}
      <div className="bg-white/10 backdrop-blur-xl rounded-2xl p-6 mb-6 border border-white/20">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
          <div>
            <h2 className="text-3xl font-bold text-white flex items-center gap-3">
              <span className="text-4xl">🎓</span> Diving Courses
            </h2>
            <p className="text-cyan-200 mt-1">Manage course enrollments for kids and adults</p>
          </div>

          <div className="flex gap-4">
            <div className="bg-gradient-to-br from-green-500 to-teal-500 rounded-xl px-5 py-3 text-white">
              <p className="text-sm opacity-80">Kids Courses</p>
              <p className="text-2xl font-bold">{booking.length}</p>
            </div>
            <div className="bg-gradient-to-br from-blue-500 to-indigo-500 rounded-xl px-5 py-3 text-white">
              <p className="text-sm opacity-80">Adult Courses</p>
              <p className="text-2xl font-bold">{booking2.length}</p>
            </div>
          </div>
        </div>

        {/* Search */}
        <div className="mt-6 relative">
          <span className="absolute inset-y-0 left-0 pl-4 flex items-center text-gray-400">
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
            </svg>
          </span>
          <input
            type="text"
            placeholder="Search by student name..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="w-full md:w-96 pl-12 pr-4 py-3 bg-white/10 border border-white/20 rounded-xl 
              text-white placeholder-white/50 focus:outline-none focus:ring-2 focus:ring-cyan-400"
          />
        </div>
      </div>

      {/* Kids Courses Table */}
      <div className="bg-white/10 backdrop-blur-xl rounded-2xl overflow-hidden border border-white/20 mb-8">
        <div className="bg-gradient-to-r from-green-600 to-teal-600 px-6 py-4">
          <h3 className="text-xl font-bold text-white flex items-center gap-2">
            <span>👶</span> Kids Diving Courses
          </h3>
        </div>
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead>
              <tr className="bg-white/5">
                <th className="px-4 py-4 text-left text-white/80 font-semibold">Name</th>
                <th className="px-4 py-4 text-left text-white/80 font-semibold">Phone</th>
                <th className="px-4 py-4 text-left text-white/80 font-semibold">Age</th>
                <th className="px-4 py-4 text-left text-white/80 font-semibold">Stars Level</th>
                <th className="px-4 py-4 text-left text-white/80 font-semibold">Action</th>
              </tr>
            </thead>
            <tbody>
              {filteredTrips.length === 0 ? (
                <tr>
                  <td colSpan="5" className="text-center py-8 text-white/50">
                    <p>No kids enrolled yet</p>
                  </td>
                </tr>
              ) : (
                filteredTrips.map((booking, index) => (
                  <tr key={booking.id} className={`border-b border-white/10 hover:bg-white/5 transition-colors
                    ${index % 2 === 0 ? 'bg-white/5' : ''}`}>
                    <td className="px-4 py-3 text-white font-medium">{booking.firstname}</td>
                    <td className="px-4 py-3 text-cyan-300">{booking.phone}</td>
                    <td className="px-4 py-3">
                      <span className="bg-green-500/30 text-green-200 px-3 py-1 rounded-full text-sm">
                        {booking.age}
                      </span>
                    </td>
                    <td className="px-4 py-3 text-yellow-400">{booking.stars}</td>
                    <td className="px-4 py-3">
                      <button
                        onClick={() => handleDelete(booking.id)}
                        className="bg-red-500/20 hover:bg-red-500 text-red-300 hover:text-white 
                          px-4 py-2 rounded-lg transition-all duration-300 flex items-center gap-2"
                      >
                        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                        </svg>
                        Delete
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>

      {/* Adult Courses Table */}
      <div className="bg-white/10 backdrop-blur-xl rounded-2xl overflow-hidden border border-white/20">
        <div className="bg-gradient-to-r from-blue-600 to-indigo-600 px-6 py-4">
          <h3 className="text-xl font-bold text-white flex items-center gap-2">
            <span>🤿</span> Adult Diving Courses
          </h3>
        </div>
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead>
              <tr className="bg-white/5">
                <th className="px-4 py-4 text-left text-white/80 font-semibold">Name</th>
                <th className="px-4 py-4 text-left text-white/80 font-semibold">Phone</th>
                <th className="px-4 py-4 text-left text-white/80 font-semibold">Age</th>
                <th className="px-4 py-4 text-left text-white/80 font-semibold">Stars Level</th>
                <th className="px-4 py-4 text-left text-white/80 font-semibold">Action</th>
              </tr>
            </thead>
            <tbody>
              {filteredTrips2.length === 0 ? (
                <tr>
                  <td colSpan="5" className="text-center py-8 text-white/50">
                    <p>No adults enrolled yet</p>
                  </td>
                </tr>
              ) : (
                filteredTrips2.map((booking2, index) => (
                  <tr key={booking2.id} className={`border-b border-white/10 hover:bg-white/5 transition-colors
                    ${index % 2 === 0 ? 'bg-white/5' : ''}`}>
                    <td className="px-4 py-3 text-white font-medium">{booking2.firstname}</td>
                    <td className="px-4 py-3 text-cyan-300">{booking2.phone}</td>
                    <td className="px-4 py-3">
                      <span className="bg-blue-500/30 text-blue-200 px-3 py-1 rounded-full text-sm">
                        {booking2.age}
                      </span>
                    </td>
                    <td className="px-4 py-3 text-yellow-400">{booking2.stars}</td>
                    <td className="px-4 py-3">
                      <button
                        onClick={() => handleDelete2(booking2.id)}
                        className="bg-red-500/20 hover:bg-red-500 text-red-300 hover:text-white 
                          px-4 py-2 rounded-lg transition-all duration-300 flex items-center gap-2"
                      >
                        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                        </svg>
                        Delete
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

export default Course;